const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://p1wfeo05td.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://k99i3buju2.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.demo.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.demo.forwoodsafety.com',
    WEBSOCKET: 'wss://4ttf2gjoi3.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
